<template>
  <div class="cinemalistApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="header">
      <div class="search">
        <div class="Location" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>{{setMovieInfo.name}}</span>
        </div>
        <div class="inpTxt">
          <i class="el-icon-search"></i>
          <input type="text" v-model="keywords" @input="getSearch" :placeholder="'搜索'+placeholderTxt+'名称'">
          <button @click="getSearch">搜索</button>
        </div>
      </div>
    </div>
    <div style="height:50px;"></div>
    <dl>
      <dd v-for="(item,i) in (pageCinema == 0 ? setCinema : searchCinema)" @click="$router.push('cinema?id='+item.id+'&movie='+setMovieInfo.id)">
        <h2>{{item.name}}</h2>
        <p>{{item.address}}</p>
        <p><i class="el-icon-location-information"></i>{{getDistance(item.lat,item.lon,cityData.latitude,cityData.longitude)}}KM</p>
        <!--<p class="last">￥<font>0.00</font>起</p>-->
      </dd>
    </dl>

    <div class="moreAll" @click="getMoreAll1" v-if="setCinema.total >= (pageCinema+1)*30 ">查看更多<i class="el-icon-arrow-right"></i></div>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        types:0,
        timestamp:0,
        setMovieDates:[],
        setMovieInfo:[],
        setCinema:[],
        cityCode:'',
        pageCinema:0,
        placeholderTxt:'影院',
        keywords:'',
        dates:'',
        cityData:[],
        moviesId:'',
        searchCinema:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      var id = this.$route.query.id
      this.moviesId = id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/cinemalist?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }

    },
    mounted() {
      this.timestamp = Date.parse(new Date());
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{

        if(localStorage.getItem('cCode') == null){
          this.getMovieDates();
        }else{
          var cCode = JSON.parse(localStorage.getItem('cCode'));
          if(cCode.expires <= Date.parse(new Date())){
            localStorage.removeItem('cCode');
            this.getMovieDates();
          }else{
            this.cityData = cCode;
            this.getMovieDates();
          }
          
        }
      }
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getDistance:function(lat1, lon1, lat2, lon2){
        const R = 6371; // 地球半径（km）
        const dLat = this.deg2rad(lat2 - lat1);
        const dLon = this.deg2rad(lon2 - lon1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance.toFixed(2);
      },
      deg2rad:function(deg) {
        return deg * (Math.PI / 180);
      },
      getMovieDates:function(){
        var that = this;
        var id = this.$route.query.id
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/movieDetail',
          data:{
            movieId:id
          },
          dataType:'json',
          success:function(data){
            that.setMovieInfo = data.data;
            that.getCinema();
            that.fullscreenLoading = false;
          }
        })
      },
      
      getSearch:function(){
          this.pageCinema = 1;
          if(this.keywords === ''){
            this.pageCinema = 0;
            return false;
          };
          var value = this.keywords;
          var res = this.setCinema.filter(function(item){
            return item.name.indexOf(value) > -1
          })
          this.searchCinema = res;
        
      },
      getCinema:function(){
        var that = this;
        var id = this.$route.query.id
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/cinema',
          data:{
            cityCode:that.cityData.cityCode,
          },
          dataType:'json',
          success:function(data){
            if(that.pageCinema == 0){
              that.setCinema = data.data;
            }
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .cinemalistApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .cinemalistApp .header{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    z-index:99;
    background:#ececec;
  }
  .cinemalistApp .header .search{
    height:40px;
  }
  .cinemalistApp .header .search .inpTxt{
    float:left;
    height:40px;
    width:65%;
    position:relative;
  }
  .cinemalistApp .header .search .inpTxt i{
    position:absolute;
    top:50%;
    left:15px;
    font-size:18px;
    transform: translateY(-50%);
    margin-top:3px;
    color:#666
  }

  .cinemalistApp .header .search .inpTxt button{
    position:absolute;
    top:50%;
    right:5px;
    font-size:18px;
    transform: translateY(-50%);
    margin-top:3px;
    color:#fff;
    background:#3F9DEC;
    border:0;
    height:35px;
    border-radius:0 40px 40px 0;
    padding:0 13px;
    font-size:16px;
  }
  .cinemalistApp .header .search input{
    border:none;
    outline:none;
    border-radius:40px;
    font-size:16px;
    padding:0 10px 0 40px;
    margin-top:5px;
    width:80%;
    height:35px;
  }
  .cinemalistApp .header .Location{
    float:left;
    line-height:45px;
    margin-left:3%;
    width:30%
  }
  .cinemalistApp .header .Location span{
    float:left;
    width:80%;
    font-size:15px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color:#000;
    margin-left:3px
  }
  .cinemalistApp .header .Location i{
    font-size:13px;
    color:#000;
    float:left;
    line-height:45px;
  }
  .cinemalistApp .header .tab{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    height:45px;
    background:#ececec;
    width:100%;
  }
  .cinemalistApp .tab .item{
    width:25%;
    height:45px;
    line-height:45px;
    font-size:16px;
    color:#666;
    text-align:center;
  }
  .cinemalistApp .tab .on{
    position:relative;
    color:#000;
    font-weight:bold;
  }
  .cinemalistApp .tab .on:after{
    position:absolute;
    content:'';
    bottom:6px;
    background: linear-gradient(-90deg, #FE506A, #FE5CA3);
    width:25px;
    height:4px;
    left:50%;
    transform: translateX(-50%);
    border-radius: 5px;
  }
  .cinemalistApp dl{
    width:94%;
    margin:0 auto;
    padding-bottom:10px
  }
  .cinemalistApp dl dd{
    background:#fff;
    border-radius: 6px;
    margin-bottom:10px;
    padding:10px;
    position:relative;
  }
  .cinemalistApp dl dd h2{
    font-size:16px;
    font-weight:bold;
  }
  .cinemalistApp dl dd p{
    color:#666;
    font-size:14px;
    padding-top:10px;
  }
  .cinemalistApp dl dd p.last{
    font-size:11px;
    color:#f00;
  }
  .cinemalistApp dl dd p.last font{
    color:#f00;
    font-size:16px;
    font-weight:bold;
    padding-right:1px
  }
  .cinemalistApp .moreAll{
    text-align:center;
    padding-bottom:15px;
    color:#3F9DEC;
    font-size:15px;
  }
</style>